/* eslint-disable react/no-array-index-key, react/no-danger */
import {
  Row,
  Card,
  FormGroup,
  CardTitle
} from "reactstrap";

import { scroller } from "react-scroll";
import { Colxx } from "../../components/common/CustomBootstrap";
import Firebaselogin from "./firebaselogin";
import Footer from "../app/Nav/Footer";
import SignUp from "./signUp";
// import Header from "../app/Nav/header";
import logo from "../../assets/logos/teamanics_logo.png";
import ClientNavBar from "../app/Nav/clientnavbar";

const Login = () => {

    const scrollTo = (event, target) => {
        event.preventDefault();
        scroller.scrollTo(target, {
            duration: 500,
            delay: 0,
            smooth: "easeInOutQuart",
            offset: -100,
        });
        return false;
    };

    return (
      <>
        <div>
          <div>
            {window.localStorage.getItem("account") == "NewUser" ? (
              <div className="registerpage">
              <Row className="h-100">
                <Colxx xxs="12" md="10" className="mx-auto my-auto">
                  <Card className="auth-card">
                    <div className="position-relative image-side ">
                      <img alt="Teamanics" src={logo}/>
                    </div>
                    <div className="signup">
                        <SignUp />
                    </div>
                  </Card>
                </Colxx>
              </Row>
              </div>
            ) :(
              <>
              <div className="loginimg">
                <Row className="h-100  t-loginpage">
                  <div >
                    <div>
                      <div className="position-relativefirebase image-sideview ">
                        <p className="text-white h2"></p>
                        <p className="white mb-0"/>
                          <div >
                           <ClientNavBar/>
                            <CardTitle className="mb-4">
                            </CardTitle>
                            <FormGroup className="form-group   mb-4">
                             <Firebaselogin />
                            </FormGroup>
                          </div>
                        <p/>
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
              <Footer/></>
            )}
          </div>
        </div>
      </>
    );

}

export default Login;
